import styled from "@emotion/styled";
import { BUTTON_STYLE_PROPERTIES_BY_SIZE_MAP } from "../constants";
import { BaseButtonStyledProps } from "../types";
import { getButtonBackgroundColor } from "./getButtonBackgroundColor";
import { getButtonBorder, getUnderlineOffset } from "./getButtonBorder";
import { getButtonBorderRadius } from "./getButtonBorderRadius";
import { getButtonFocusRingStyles } from "./getButtonFocusRingStyles";
import { getButtonFontSize, getButtonFontWeight, getButtonLineHeight } from "./getButtonFontStyles";
import { getButtonMinWidth } from "./getButtonMinWidth";
import { getButtonMotion } from "./getButtonMotion";
import { getButtonPadding } from "./getButtonPadding";
import { getButtonTextColor } from "./getButtonTextColor";
import { getTextDecoration } from "./getButtonTextDecoration";

const getCursor = ({ state }: BaseButtonStyledProps) => (state.isDisabled ? "not-allowed" : "pointer");

const getWidth = ({ shouldFitContainer }: BaseButtonStyledProps) => (shouldFitContainer ? "100%" : undefined);

const getHeight = ({ size, appearance }: BaseButtonStyledProps) => {
    return appearance !== "link" ? `${BUTTON_STYLE_PROPERTIES_BY_SIZE_MAP[size].height}px;` : "auto";
};

export const BaseButtonStyled = styled("button")<BaseButtonStyledProps>`
    text-transform: none; // Remove inheritance of text transform in Firefox
    overflow: visible; // Show overflow in Edge
    margin: 0; // Remove margin in Firefox and Safari
    padding: 0; // Remove padding in webkit
    outline: none; // Remove default focus outline in various browsers
    font-family: inherit; // Ensure we inherit from parent since many browsers override this in user-agent stylesheet.

    &::-moz-focus-inner {
        border: 0;
        margin: 0;
        padding: 0;
    }

    display: inline-flex;
    box-sizing: border-box;
    align-items: center;

    height: ${getHeight};
    width: ${getWidth};
    min-width: ${getButtonMinWidth};
    max-width: 100%; // if the parent is smaller than the button, we want to truncate
    padding: ${getButtonPadding};
    border: ${getButtonBorder};
    text-align: center;
    border-radius: ${getButtonBorderRadius};
    background-color: ${getButtonBackgroundColor};
    font-size: ${getButtonFontSize};
    line-height: ${getButtonLineHeight};
    font-weight: ${getButtonFontWeight};
    color: ${getButtonTextColor};
    white-space: nowrap;
    cursor: ${getCursor};
    text-decoration: ${getTextDecoration}; // if the href prop is used, an anchor tag will be rendered instead
    position: relative;
    transition: ${getButtonMotion};
    text-underline-offset: ${getUnderlineOffset};
    ${getButtonFocusRingStyles}
`;
